import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_quotation_list = createAsyncThunk("quotation", async (data) => {
  const body = new FormData();
  body.append("action","list");
  body.append("page", data?.page || 1);
  body.append("limit", data?.rows || 10);
  const response = await fetch(baseUrl + "quotation.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log("API Response:", res);
  return res;
});

export const get_all_quotation_details = createAsyncThunk(
    "all_qoutationList",
    async (id) => {
      const body = new FormData();
      body.append("action", "list_by_id");
      body.append("id", id); // Use the actual ID instead of hardcoded 1

      const response = await fetch(baseUrl + "quotation.php", { // Fixed endpoint
        method: "POST",
        body: body,
      });
      const res = await response.json();
      console.log("Quotation details response:", res);
      return res;
    }
  );

const initialState = {
  quotation_list: [],
  loading: false,
  all_quotation_list: [],
  all_loading: false, // Added this missing state
  total_quotation_count: 0,
  error: null,
};

const quotationSlice = createSlice({
  name: "quotation",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(get_quotation_list.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(get_quotation_list.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to fetch data";
    });
    builder.addCase(get_quotation_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      console.log("Redux received data:", data);
      
      if (data.success) {
        state.total_quotation_count = Number(data.totalcount) || 0;
        state.quotation_list = data.responselist || [];
        console.log("Updated quotation_list:", state.quotation_list);
      } else {
        state.quotation_list = [];
        state.total_quotation_count = 0;
      }
    });

    builder.addCase(get_all_quotation_details.pending, (state, action) => {
        state.all_loading = true;
      });
      builder.addCase(get_all_quotation_details.rejected, (state, action) => {
        state.all_loading = false;
      });
      builder.addCase(get_all_quotation_details.fulfilled, (state, action) => {
        state.all_loading = false;
        const data = action.payload;
        if (data.success) {
          state.all_quotation_list = data?.responselist;
        } else {
          state.all_quotation_list = [];
        }
      });
  },
});

export default quotationSlice.reducer;